module.exports = __webpack_public_path__ + "static/media/download.5fa2761e.svg";